import React, { Component } from "react";
import { LineChart, Line, ResponsiveContainer } from "recharts";
import PropTypes from "prop-types";

// Graph component;
class Graph extends Component {
  static propTypes = {
    data: PropTypes.array.isRequired
    // array of objects for graph points [{name: "Point A", pv: 2400},...]
  };

  render() {
    const { data } = this.props;
    return (
      <ResponsiveContainer width="100%" height={42}>
        <LineChart data={data}>
          <Line type="monotone" dataKey="pv" stroke="#21c2c6" strokeWidth={2} />
        </LineChart>
      </ResponsiveContainer>
    );
  }
}

export default Graph;



// WEBPACK FOOTER //
// ./src/components/landing/common/Graph.js